/**
 * @generated SignedSource<<5865b3993a3977c607f06d215c2ce8ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPaymentMethodForm_user$data = {
  readonly activeUserPaymentMethods: {
    readonly totalCount: number;
  };
  readonly firstName: string;
  readonly lastName: string;
  readonly middleName: string | null;
  readonly stripeCustomerId: string | null;
  readonly userAddresses: {
    readonly nodes: ReadonlyArray<{
      readonly address: {
        readonly city: string;
        readonly country: string;
        readonly postalCode: string;
        readonly stateOrProvince: string;
        readonly street1: string;
        readonly street2: string | null;
      } | null;
    }>;
  };
  readonly " $fragmentType": "UserPaymentMethodForm_user";
};
export type UserPaymentMethodForm_user$key = {
  readonly " $data"?: UserPaymentMethodForm_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPaymentMethodForm_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "equalTo": true
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserPaymentMethodForm_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "middleName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeCustomerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "isPrimary": (v0/*: any*/)
          }
        }
      ],
      "concreteType": "UserAddressesConnection",
      "kind": "LinkedField",
      "name": "userAddresses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserAddress",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "street1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "street2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "stateOrProvince",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "postalCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userAddresses(filter:{\"isPrimary\":{\"equalTo\":true}})"
    },
    {
      "alias": "activeUserPaymentMethods",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "isActive": (v0/*: any*/)
          }
        }
      ],
      "concreteType": "UserPaymentMethodsConnection",
      "kind": "LinkedField",
      "name": "userPaymentMethods",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "userPaymentMethods(filter:{\"isActive\":{\"equalTo\":true}})"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "9f9c99e7148fcc34848206e798387055";

export default node;
